<template>
    <div class="card-footer">
        <form v-on:submit="submit">
            <div class="input-group">
                <div class="input-group-append">
                    <span class="input-group-text attach_btn"><i class="fas fa-paperclip"></i></span>
                </div>
                <textarea v-model="newMessage" :disabled="inputDisabled" class="form-control type_msg" placeholder="Type your message..."></textarea>
                <div class="input-group-append">
                    <button :disabled="inputDisabled" class="input-group-text send_btn"><i class="fas fa-location-arrow"></i></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "ChatInputComponent",
        data() {
            return {
                newMessage: "",
                inputDisabled: false
            }
        },
        props: {
            conversationId: String
        },
        methods: {
            submit: function (event) {
                event.preventDefault();

                if (this.newMessage === "") return;

                this.inputDisabled = true;
                axios.post(`/conversations/new_message`, { message: this.newMessage, conversation_id: this.conversationId})
                    .then(function () {
                        this.newMessage = "";
                        this.inputDisabled = false;
                    }.bind(this));
            }
        },
    }
</script>

<style scoped>

</style>
